<template>
  <div class="sidebar-resume-block">
    <div class="sidebar-resume-block--title">
      <div>
        {{ title }}
        <span
          v-if="info"
          v-html="svg_info"
          v-b-popover.hover.top="info"
          style="margin-top: -2.5px"
        ></span>
      </div>
      <div v-if="Object.keys(title_content || {}).length > 0" class="d-flex gap-5px">
        <div v-if="title_content.icon" v-html="title_content.icon" style="margin-top: -1px"></div>
        <div v-if="title_content.text" class="bold text-content">
          {{ title_content.text }}
        </div>
      </div>
    </div>
    <hr />
    <div class="sidebar-resume-block--body">
      <slot name="default"></slot>
    </div>
    <hr v-if="$slots.footer" />
    <div class="sidebar-resume-block--footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
import { info } from '../../svg/common';

export default {
  name: 'sidebar-resume-block',
  props: {
    title: String,
    info: {
      type: String,
      default: () => '',
    },
    title_content: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      svg_info: info,
    };
  },
};
</script>

<style lang="scss" scoped>
.sidebar-resume-block {
  hr {
    padding: 0;
    margin: 0;
  }

  display: flex;
  flex-direction: column;

  &--title {
    display: flex;
    justify-content: space-between;
    color: $primary;
    margin-bottom: 5px;
  }

  &--body {
    display: flex;
    flex-direction: column;
    gap: 5px;
    padding: 15px 0;
  }

  &--footer {
    margin-top: 5px;
    width: 100%;
  }
}
</style>
